import { eventHasRun } from '../../utils/eventTracker';

export const DDC_FORM_PAYMENTCALC = 'ddc.form.paymentCalcInit';

function paymentCalcInit({ currentTarget }) {
	let eventObject;
	const widgetId =
		currentTarget.closest?.('[data-widget-id]')?.dataset.widgetId;

	if (!eventHasRun(widgetId)) {
		eventObject = {
			eventType: DDC_FORM_PAYMENTCALC,
			// this event always pushed an empty eventData object, keeping in case something relies on this
			eventData: {}
		};
	}

	return eventObject;
}

export default paymentCalcInit;
